module.exports = __webpack_public_path__ + "img/user-portal-tooltip.0d6882ee.png";